import BreadCrumbs from '@/components/atom/BreadCrumbs';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { zIndex } from '@/constants/zIndex';
import DNSearchBar from '@/design-components/organisms/dnsearch-bar';
import { SearchTotalMedicineDictionaryViewModel } from '@/features/medicine-dictionary/hook/useSearchTotalMedicineDictionaryViewModel';
import SearchPopularMedicineDictionary from '@/features/medicine-dictionary/ui/SearchPopularMedicineDictionary';
import SearchTotalMedicineDictionary from '@/features/medicine-dictionary/ui/SearchTotalMedicineDictionary';
import { MedicineDictionaryViewModel } from '@/hooks/medicine-dictionary/useMedicineDictionaryViewModel';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';

interface Props {
  viewModel: MedicineDictionaryViewModel;
  client: Client;
  medicineViewModel: SearchTotalMedicineDictionaryViewModel;
}

const MedicineDictionaryTemplate = (props: Props) => {
  const shouldShowBreadCrumbs = props.client.clientType === ClientType.WEB;
  const topPosition = props.client.clientType === ClientType.MOBILE_WEB ? '60px' : '0px';

  return (
    <TemplateLayout.Wrapper>
      <div suppressHydrationWarning>
        {shouldShowBreadCrumbs && (
          <BreadCrumbs.Wrapper>
            <BreadCrumbs
              visible
              name='의약품 사전'
              type='medicine_dictionary'
              path={`${ROUTES.MEDICINE_DICTIONARY.HOME.path}`}
            />
          </BreadCrumbs.Wrapper>
        )}
      </div>

      <h1 className='typography-ui-22sb px-[24px] py-[16px] text-gray-900'>의약품 사전</h1>

      <div
        className='px-[24px] py-[16px]'
        style={{
          zIndex: zIndex.AppHeader,
          top: topPosition,
        }}
        suppressHydrationWarning
      >
        <DNSearchBar
          value={props.viewModel.keyword}
          placeholder={'약 이름 또는 성분 등'}
          shouldShowResetButton={!!props.viewModel.keyword}
          searchInputRef={props.viewModel.searchInputRef}
          onSubmit={props.viewModel.handleSubmit}
          onReset={props.viewModel.handleResetSearchKeyword}
          onChange={props.viewModel.handleChangeSearchKeyword}
        />
      </div>

      <SearchPopularMedicineDictionary />
      <div className='h-[16px] bg-gray-30' />
      <SearchTotalMedicineDictionary viewModel={props.medicineViewModel} />
    </TemplateLayout.Wrapper>
  );
};

export default MedicineDictionaryTemplate;
